import React from "react";
import "./Header.css";

export const Header = (props) => {
  const handleback = () => {
    props.sendBackData();
  };
  return (
    <section className="header_section">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 d-flex align-items-center">
            <button className={`back_button ${props.count === 0 ? 'd-none' : 'd-flex'}`} onClick={() => handleback()} disabled={props.count === 0 ? true : false}>
              Back
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
